import useAccountQuery from 'api/queries/useAccountQuery';
import useSubscriptionQuery from 'api/queries/useSubscriptionQuery';
import { Divider } from 'honeydew/Divider';

import Birthday from './Birthday';
import Email from './Email';
import Name from './Name';
import Phone from './Phone';

function PersonalInfo() {
    const { data: account } = useAccountQuery();
    const { data: subscription } = useSubscriptionQuery();

    return (
        <div className="grow space-y-20">
            <Name subscription={subscription} />
            <Divider />
            <Email email={subscription?.email} />
            <Divider />
            <Phone subscription={subscription} />
            <Divider />
            <Birthday
                customerID={account?.customerID}
                subscriptionID={subscription?.id}
                birthday={subscription?.dateOfBirth}
            />
        </div>
    );
}

export default PersonalInfo;
